const acceptanceLevels = {
  en: {
    tooltip: {
      H: "Nearly everywhere accepts your card here",
      G: "Many locations accept your card here",
      J: "Select locations accept your card here",
      "NO COVERAGE": "No locations accept your card yet",
    },
    legend: {
      headline: "Global Acceptance",
    },
    modal: {
      headline: "Global Acceptance",
    },
    levels: {
      H: {
        title: "Nearly Everywhere",
        desc: "Almost all locations across the country accept your card.",
      },
      G: {
        title: "Many Locations",
        desc: "Many locations accept your card, especially those in popular travel destinations.",
      },
      J: {
        title: "Select Locations",
        desc: "Growing number of locations accept your card, especially restaurants, hotels and retailers.",
      },
      "NO COVERAGE": {
        title: "No Locations Yet",
        desc: "Your card is not yet accepted here.",
      },
    },
    headlines: {
      H: "Most locations across the country accept your card.",
      G: "Many locations accept your card, especially those in popular travel destinations.",
      J: "Growing number of locations accept your card, especially restaurants, hotels and retailers.",
      "NO COVERAGE":
        "Your card is not yet accepted here—but we’re working on it. Our network is expanding all the time.",
    },
  },
  es: {
    tooltip: {
      H: "aaa",
      G: "bbb",
      J: "ccc",
      "NO COVERAGE": "ddd",
    },
    legend: {
      headline: "Spanish",
    },
  },
};

export default acceptanceLevels;
